<template>
    <section v-if="bannerKind" class="projects-primary-banner">
        <div v-if="bannerKind === 'onboard'" class="mp-card mp-card--onboard">
            <div class="ob-body">
                <div class="ob-badge">Data Heroes</div>
                <div class="ob-title">Начните бесплатный<br>тест 14 дней</div>
                <div class="ob-desc">
                    CRM-маркетинг для салонов и клиник: рассылки, аналитика, возврат клиентов — всё в едином окне.
                </div>
                <button type="button" class="ob-cta" @click="goToCreateProject">
                    <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
                        <path
                            d="M7 1v12M1 7h12"
                            stroke="currentColor"
                            stroke-width="1.7"
                            stroke-linecap="round"
                        />
                    </svg>
                    Создать проект
                </button>
                <div class="ob-note">Без привязки карты · Запуск за 3–5 дней</div>
            </div>
            <div class="ob-visual" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                    <g
                        transform="rotate(45 12 12)"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path
                            d="M12 3c2.55 3.35 3.7 6.9 3.65 10.15-.04 1.5-.5 2.9-1.35 4.1H9.7c-.85-1.2-1.31-2.6-1.35-4.1C8.3 9.9 9.45 6.35 12 3z"
                        />
                        <circle cx="12" cy="8.7" r="1.35" />
                        <path d="M9.85 13.7 6.4 17.15 9.8 15.7" />
                        <path d="M14.15 13.7 17.6 17.15 14.2 15.7" />
                        <path d="M10.25 17.25c.4 1.35 1.05 2.4 1.75 3.2.7-.8 1.35-1.85 1.75-3.2" />
                    </g>
                </svg>
            </div>
        </div>

        <div
            v-else-if="bannerKind === 'skeleton'"
            class="mp-card mp-card--channels mp-card--skeleton"
            aria-hidden="true"
        >
            <div class="ch-head">
                <div>
                    <div class="sk-bone sk-bone--tag"></div>
                    <div class="sk-bone sk-bone--title"></div>
                    <div class="sk-bone sk-bone--desc"></div>
                </div>
            </div>
            <div class="ch-list">
                <div v-for="n in 2" :key="n" class="ch-item">
                    <div class="ch-item-top">
                        <div class="sk-bone sk-bone--icon"></div>
                        <div class="sk-bone sk-bone--name"></div>
                    </div>
                    <div class="sk-bone sk-bone--btn"></div>
                </div>
            </div>
        </div>

        <div v-else-if="bannerKind === 'channels'" class="mp-card mp-card--channels">
            <div class="ch-head">
                <div>
                    <div class="ch-tag">Следующий шаг</div>
                    <div class="ch-title">Подключите канал рассылок</div>
                    <div class="ch-desc">Без канала рассылки не отправляются — выберите удобный способ</div>
                </div>
            </div>
            <div class="ch-list">
                <div
                    v-for="channel in channelCards"
                    :key="channel.type"
                    class="ch-item"
                >
                    <div class="ch-item-top">
                        <div class="ch-icon" :class="channel.tone" aria-hidden="true">
                            <img :src="channel.icon" :alt="channel.name" />
                        </div>
                        <div class="ch-name">{{ channel.name }}</div>
                    </div>
                    <button
                        type="button"
                        class="ch-btn"
                        :class="channel.tone"
                        @click="$emit('connect', channel.type)"
                    >
                        Подключить
                    </button>
                </div>
            </div>
        </div>

        <div v-else-if="bannerKind === 'marketplace'" class="mp-card mp-card--next">
            <div
                v-for="item in marketplaceCards"
                :key="item.integrationId"
                class="next-item"
            >
                <div class="next-icon" :class="item.tone" aria-hidden="true">
                    <svg v-if="item.tone === 'w'" viewBox="0 0 24 24" fill="none">
                        <path d="M8 4h8a2 2 0 012 2v14l-6-3-6 3V6a2 2 0 012-2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                        <path d="M9 9h6M9 12h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <svg v-else-if="item.tone === 'i'" viewBox="0 0 24 24" fill="none">
                        <path d="M12 4 2 9l10 5 8-4v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 11.5V16c0 1 2.7 3 6 3s6-2 6-3v-4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg v-else viewBox="0 0 24 24" fill="none">
                        <path d="M5 4h4l2 5-3 2a12 12 0 005 5l2-3 5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div>
                    <div class="next-label">Маркетплейс</div>
                    <div class="next-title">{{ item.title }}</div>
                </div>
                <div class="next-desc">{{ item.desc }}</div>
                <button
                    type="button"
                    class="next-btn"
                    :class="item.tone"
                    @click="$emit('open-marketplace', item)"
                >
                    Подробнее
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import { CHANNEL_TYPES } from '@/vars/general'
import { shouldShowChannelsBanner } from '@/helpers/projects/connectMailingChannel'
import { hydrateMailingChannelPhones } from '@/helpers/projects/runConnectMailingChannel'
import cfg from '@root/config'

const marketplaceIds = cfg.marketplaceModulesIds[cfg.buildType]

const BANNER_PRIORITY = [
    {
        kind: 'onboard',
        match: ({ projects }) => !projects.length,
    },
    {
        kind: 'skeleton',
        match: ({ projects, phoneLookupDone }) =>
            !phoneLookupDone && shouldShowChannelsBanner(projects),
    },
    {
        kind: 'channels',
        match: ({ projects, phoneLookupDone }) =>
            phoneLookupDone && shouldShowChannelsBanner(projects),
    },
    {
        kind: 'marketplace',
        match: ({ projects }) => projects.some(project => !project?.isOnBoardingActive),
    },
]

export default {
    name: 'ProjectsPrimaryBanner',
    props: {
        projects: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        phoneLookupDone: false,
        phoneLookupGeneration: 0,
    }),
    computed: {
        bannerKind() {
            const ctx = {
                projects: this.projects || [],
                phoneLookupDone: this.phoneLookupDone,
            }
            const matched = BANNER_PRIORITY.find(rule => rule.match(ctx))
            return matched ? matched.kind : null
        },
        channelCards() {
            return [
                {
                    type: CHANNEL_TYPES.telegramChannel,
                    name: 'Telegram',
                    tone: 'tg',
                    icon: require('@/assets/icons/telegram-white.svg'),
                },
                {
                    type: CHANNEL_TYPES.maxChannel,
                    name: 'MAX',
                    tone: 'max',
                    icon: require('@/assets/icons/max-white.svg'),
                },
            ]
        },
        marketplaceCards() {
            return [
                {
                    integrationId: marketplaceIds.crmSettings,
                    title: 'Внедрение CRM-маркетинга',
                    desc: 'Экспертная настройка DH под бизнес: сегменты, офферы, скрипты, каскад и обучение',
                    tone: 'w',
                },
                {
                    integrationId: marketplaceIds.salesTraining,
                    title: 'Интенсив по продажам',
                    desc: 'Живое обучение администраторов продажам, диалогам и работе с возражениями',
                    tone: 'i',
                },
                {
                    integrationId: marketplaceIds.zvonoBot,
                    title: 'Аудиорассылки DH',
                    desc: 'Автоматический обзвон потеряшек — настройка под ключ',
                    tone: 't',
                },
            ]
        },
    },
    methods: {
        goToCreateProject() {
            this.$router.push({ name: 'OnBoardingCreateProject' })
        },
        async refreshPhoneLookup() {
            this.phoneLookupGeneration += 1
            const generation = this.phoneLookupGeneration
            this.phoneLookupDone = false
            const projects = this.projects || []
            if (!shouldShowChannelsBanner(projects)) {
                if (generation === this.phoneLookupGeneration) this.phoneLookupDone = true
                return
            }
            await hydrateMailingChannelPhones(this.$store, projects)
            if (generation === this.phoneLookupGeneration) this.phoneLookupDone = true
        },
    },
    watch: {
        projects: {
            immediate: true,
            handler() {
                this.refreshPhoneLookup()
            },
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
@import '@/assets/styles/skeleton.sass'

.projects-primary-banner
    margin-bottom: 14px

.mp-card
    background: #fff !important
    border-radius: 16px
    overflow: hidden
    border: 1.5px solid #E6E9F0
    box-shadow: 0 1px 2px rgba(26, 26, 46, .04)

.mp-card--onboard
    border-color: rgba(82, 90, 213, .3)
    display: grid
    grid-template-columns: 1fr 168px

.ob-body
    padding: 22px 22px 22px 26px
    min-width: 0

.ob-visual
    background: radial-gradient(130% 130% at 100% 0%, #2A2660, #15132E)
    display: flex
    align-items: center
    justify-content: center
    position: relative
    overflow: hidden
    color: $pop-new !important
    min-height: 100%

    &::before
        content: ''
        position: absolute
        width: 150px
        height: 150px
        border-radius: 50%
        background: radial-gradient(circle, rgba(82, 90, 213, .5), transparent 70%)
        top: -44px
        right: -44px

    svg
        width: 69px
        height: 69px
        position: relative
        z-index: 1

.ob-badge
    display: inline-flex
    align-items: center
    gap: 6px
    background: $bcg-card-new
    border: 1px solid rgba(82, 90, 213, .2)
    color: $main-new !important
    padding: 4px 11px
    border-radius: 999px
    font-family: $font-family-base !important
    font-size: 9.5px !important
    font-weight: 800 !important
    letter-spacing: .06em
    text-transform: uppercase
    margin-bottom: 12px
    line-height: 1.2

.ob-title
    font-family: $font-family-base !important
    font-size: 18px !important
    font-weight: 900 !important
    color: $dark-new !important
    letter-spacing: -.03em
    line-height: 1.15
    margin-bottom: 8px

.ob-desc
    font-family: $font-family-base !important
    font-size: 13px !important
    font-weight: 400 !important
    color: $muted-new !important
    line-height: 1.6
    margin-bottom: 16px

.ob-cta
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 7px
    margin: 0
    border: none
    border-radius: 10px
    background: $main-new
    color: #fff !important
    padding: 11px 19px
    font-family: $font-family-base !important
    font-weight: 800 !important
    font-size: 13px !important
    line-height: 1
    cursor: pointer
    box-shadow: 0 3px 14px rgba(82, 90, 213, .3)
    transition: background .15s, transform .15s

    svg
        width: 14px
        height: 14px
        flex-shrink: 0

    &:hover
        background: #454CC0
        transform: translateY(-1px)

    &:active
        transform: translateY(0)

    &:focus-visible
        outline: 2px solid rgba($main-new, .45)
        outline-offset: 2px

.ob-note
    font-family: $font-family-base !important
    font-size: 11.5px !important
    font-weight: 400 !important
    color: $muted-light-new !important
    margin-top: 9px
    line-height: 1.3

.mp-card--channels
    border-color: rgba(82, 90, 213, .25)

.mp-card--skeleton
    pointer-events: none

.sk-bone
    @include background-gradient
    animation: shine $animation-duration infinite
    border-radius: 8px

    &--tag
        width: 108px
        height: 18px
        border-radius: 999px
        margin-bottom: 8px

    &--title
        width: min(280px, 70%)
        height: 18px
        margin-top: 2px

    &--desc
        width: min(420px, 92%)
        height: 14px
        margin-top: 8px

    &--icon
        width: 34px
        height: 34px
        border-radius: 10px
        flex-shrink: 0

    &--name
        width: 92px
        height: 14px

    &--btn
        width: 100%
        height: 32px
        border-radius: 9px

.ch-head
    padding: 17px 20px 13px
    display: flex
    align-items: flex-start
    justify-content: space-between
    gap: 14px
    border-bottom: 1px solid #EFF1F6

.ch-tag
    display: inline-flex
    align-items: center
    gap: 6px
    background: $bcg-card-new
    border: 1px solid rgba(82, 90, 213, .2)
    color: $main-new !important
    padding: 3px 10px
    border-radius: 999px
    font-family: $font-family-base !important
    font-size: 9.5px !important
    font-weight: 800 !important
    letter-spacing: .06em
    text-transform: uppercase
    margin-bottom: 8px
    line-height: 1.2

.ch-title
    font-family: $font-family-base !important
    font-size: 15px !important
    font-weight: 800 !important
    color: $dark-new !important
    letter-spacing: -.02em
    line-height: 1.25

.ch-desc
    font-family: $font-family-base !important
    font-size: 12.5px !important
    font-weight: 400 !important
    color: $muted-new !important
    margin-top: 3px
    line-height: 1.45

.ch-list
    padding: 14px 16px
    display: grid
    grid-template-columns: 1fr 1fr
    gap: 12px

.ch-item
    background: #F4F5F8
    border: 1.5px solid #E6E9F0
    border-radius: 13px
    padding: 13px 14px
    display: flex
    flex-direction: column
    gap: 10px
    min-width: 0

.ch-item-top
    display: flex
    align-items: center
    gap: 10px
    min-width: 0

.ch-icon
    width: 34px
    height: 34px
    border-radius: 10px
    display: flex
    align-items: center
    justify-content: center
    flex-shrink: 0
    overflow: hidden

    img
        width: 19px
        height: 19px
        object-fit: contain

    &.tg
        background: #229ed9

    &.max
        background: linear-gradient(135deg, #5e91ff, #7b5cff 60%, #9c6dff)

.ch-name
    font-family: $font-family-base !important
    font-size: 12.5px !important
    font-weight: 800 !important
    color: $dark-new !important
    letter-spacing: -.01em
    line-height: 1.25
    min-width: 0

.ch-btn
    width: 100%
    margin: 0
    border: none
    border-radius: 9px
    padding: 9px
    font-family: $font-family-base !important
    font-weight: 800 !important
    font-size: 11.5px !important
    line-height: 1
    color: #fff !important
    cursor: pointer
    transition: filter .15s, transform .15s

    &.tg
        background: #2AABEE

    &.max
        background: #7C5CFF

    &:hover
        filter: brightness(1.05)
        transform: translateY(-1px)

    &:active
        transform: translateY(0)

    &:focus-visible
        outline: 2px solid rgba($main-new, .45)
        outline-offset: 2px

.mp-card--next
    border-color: rgba(212, 236, 56, .55)
    display: grid
    grid-template-columns: 1fr 1fr 1fr

.next-item
    padding: 18px 16px
    border-right: 1px solid #EFF1F6
    display: flex
    flex-direction: column
    gap: 11px
    min-width: 0

    &:last-child
        border-right: none

.next-icon
    width: 38px
    height: 38px
    border-radius: 11px
    display: flex
    align-items: center
    justify-content: center
    flex-shrink: 0

    svg
        width: 20px
        height: 20px

    &.w
        background: $dark-new
        color: $pop-new

    &.i,
    &.t
        background: $bcg-card-new
        color: $main-new

.next-label
    font-family: $font-family-base !important
    font-size: 9px !important
    font-weight: 800 !important
    letter-spacing: .09em
    text-transform: uppercase
    color: #8BA800 !important
    margin-bottom: 3px
    line-height: 1.2

.next-title
    font-family: $font-family-base !important
    font-size: 13.5px !important
    font-weight: 800 !important
    color: $dark-new !important
    letter-spacing: -.01em
    line-height: 1.25

.next-desc
    font-family: $font-family-base !important
    font-size: 11.5px !important
    font-weight: 400 !important
    color: $muted-new !important
    line-height: 1.5
    flex: 1

.next-btn
    width: 100%
    margin: 0
    border-radius: 9px
    padding: 9px
    font-family: $font-family-base !important
    font-weight: 800 !important
    font-size: 12px !important
    line-height: 1
    cursor: pointer
    transition: filter .15s, transform .15s, background .15s, border-color .15s

    &.w
        border: none
        background: $pop-new
        color: #1A1800 !important

    &.i,
    &.t
        background: transparent
        color: $main-new !important
        border: 1.5px solid rgba(82, 90, 213, .25)

    &:hover
        transform: translateY(-1px)

    &:active
        transform: translateY(0)

    &:focus-visible
        outline: 2px solid rgba($main-new, .45)
        outline-offset: 2px

@media (max-width: 680px)
    .mp-card--onboard
        grid-template-columns: 1fr

    .ob-visual
        display: none

    .ch-list
        grid-template-columns: 1fr

    .mp-card--next
        grid-template-columns: 1fr

    .next-item
        border-right: none
        border-bottom: 1px solid #EFF1F6

        &:last-child
            border-bottom: none
</style>
